import camelize from 'camelcase-keys-deep';

export default class SystemChange {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  user() {
    return this.env().User.getById(this.userId);
  }
}
